export enum VirtualOfficeAction {
  SETUP = "setupVirtualOffice",
  GET_VPN_MOBILE_APP = "getVpnMobileApp",
  ADD_URL_TO_INCLUDELIST = "addUrlToIncludelist",
  ADD_URL_TO_EXCLUDELIST = "addUrlToExcludelist",
  REMOVE_FROM_INCLUDELIST = "removeUrlFromIncludelist",
  REMOVE_FROM_EXCLUDELIST = "removeUrlFromExcludelist",
  SELECT_PREDEFINED_VPN_LABEL = "selectPredefinedVpnLabel",
  VIEW_ALL_IPS = "viewAllIps",
  ADD_URL_TO_URL_LIST = "addUrlToURLList",
  ENABLE_FULL_TUNNELING = "enableFullTunneling",
  DISABLE_FULL_TUNNELING = "disableFullTunneling",
  TOGGLE_FULL_TUNNELING = "toggleFullTunneling",
}

export enum RegionOption {
  KEEP_CURRENT = "keepCurrent",
  MOVE_TO_ANOTHER = "moveToAnother",
}

export const DEFAULT_VIRTUAL_OFFICE_SUBNET = "10.8.0.0/16";

export const VIRTUAL_OFFICE_SUBNET_OPTIONS = [
  "10.0.0.0/16",
  "10.0.0.0/24",
  "172.16.0.0/16",
  "172.16.0.0/24",
  "192.168.0.0/16",
  "192.168.0.0/24",
  DEFAULT_VIRTUAL_OFFICE_SUBNET,
  "10.8.0.0/24",
];

export enum NetworkSettingsAction {
  TOGGLE_ENCRYPTION_STRENGTH = "toggleEncryptionStrength",
}

export enum TrustedNetworkAction {
  ADD = "addTrustedNetwork",
  EDIT = "editTrustedNetwork",
  DELETE = "removeTrustedNetwork",
}

export enum TrustedNetworkType {
  SSID = "SSID",
  IP = "IP",
}

export enum ZtnaAction {
  ADD_ZTNA_RULE = "addZtnaRule",
  TOGGLE_ZTNA = "toggleZtna",
  ENABLE_ZTNA = "enableZtna",
  DISABLE_ZTNA = "disableZtna",
  EDIT_ZTNA_RULE = "editZtnaRule",
  DELETE_ZTNA_RULE = "deleteZtnaRule",
}

export enum SecureWebGatewayAction {
  ADD_URL_TO_ALLOWLIST = "addUrlToAllowlist",
  ADD_URL_TO_BLOCKLIST = "addUrlToBlocklist",
  EDIT_URL = "editUrl",
  EDIT_URL_GROUP = "editUrlGroup",
  ENABLE_URL_ALLOW_LIST = "enableUrlAllowList",
  ENABLE_URL_BLOCK_LIST = "enableUrlBlockList",
  DISABLE_URL_ALLOW_LIST = "disableUrlAllowList",
  DISABLE_URL_BLOCK_LIST = "disableUrlBlockList",
  IMPORT_URL_GROUP_TO_ALLOWLIST = "importUrlGroupToAllowlist",
  IMPORT_URL_GROUP_TO_BLOCKLIST = "importUrlGroupToBlocklist",
  REMOVE_FROM_ALLOWLIST = "removeUrlFromAllowlist",
  REMOVE_FROM_BLOCKLIST = "removeUrlFromBlocklist",
  VIEW_URL_LIST = "viewUrlList",
  ENABLE_URL_GROUP_ALLOW_LIST = "enableUrlGroupAllowList",
  ENABLE_URL_GROUP_BLOCK_LIST = "enableUrlGroupBlockList",
  DISABLE_URL_GROUP_ALLOW_LIST = "disableUrlGroupAllowList",
  DISABLE_URL_GROUP_BLOCK_LIST = "disableUrlGroupBlockList",
  REMOVE_URL_GROUP_FROM_ALLOW_LIST = "removeUrlGroupFromAllowList",
  REMOVE_URL_GROUP_FROM_BLOCK_LIST = "removeUrlGroupFromBlockList",
  TOGGLE_CUSTOM_DNS_FILTERING = "toggleDnsFiltering",
  TOGGLE_BASIC_DNS_FILTERING = "toggleBasicDnsFiltering",
  DOWNLOAD_EXAMPLE_FILE = "downloadSwgExampleFile",
}

export enum SecureWebGatewayCategories {
  URL = "url",
  URL_GROUP = "urlGroup",
  LOCKED_URL_GROUP = "lockedUrlGroup",
}

export enum SecureWebGatewayListFilterChoices {
  ALLOWED = "allowed",
  BLOCKED = "blocked",
  ALLOWED_DISABLED = "allowedDisabled",
  BLOCKED_DISABLED = "blockedDisabled",
}

export enum SiteToSiteTunnelsAction {
  ADD = "addTunnel",
  TEST = "testTunnel",
  EDIT = "editTunnel",
  DELETE = "deleteTunnel",
  ENABLE_TUNNEL = "enableTunnel",
  DISABLE_TUNNEL = "disableTunnel",
  DOWNLOAD_LOG = "downloadTunnelLog",
}
export enum EncryptionStrength {
  AES128 = "AES128",
  AES256 = "AES256",
}

export enum ConfigType {
  IP = "IP",
  RANGE = "RANGE",
  CIDR = "CIDR",
  DOMAIN = "DOMAIN",
}

export enum Protocol {
  ALL = "ALL",
  UDP = "UDP",
  TCP = "TCP",
}

export enum CustomDomainDnsAction {
  ADD = "addCustomDomainDns",
  REMOVE = "removeCustomDomainDns",
}

export enum ConditionalForwardingAction {
  ADD = "addConditionalForwarding",
  EDIT = "editConditionalForwarding",
  REMOVE = "removeConditionalForwarding",
}

/** Quality of a capability for the requested window, as reported by the backend. */
export enum AnalyticsCoverage {
  AVAILABLE = "AVAILABLE",
  DEGRADED = "DEGRADED",
  UNAVAILABLE = "UNAVAILABLE",
}

export enum NetworkConnectionType {
  USER = "USER",
  SITE_TO_SITE = "SITE_TO_SITE",
  VIRTUAL_OFFICE = "VIRTUAL_OFFICE",
}

export enum NetworkConnectionStatus {
  ACTIVE = "ACTIVE",
  DISCONNECTED = "DISCONNECTED",
  UNKNOWN = "UNKNOWN",
}

/** Mirrors the backend's AnalyticsRegion. Order here is the order the bars are drawn in. */
export enum NetworkAnalyticsRegion {
  NORTH_AMERICA = "NORTH_AMERICA",
  LATIN_AMERICA = "LATIN_AMERICA",
  EUROPE = "EUROPE",
  MIDDLE_EAST = "MIDDLE_EAST",
  AFRICA = "AFRICA",
  ASIA_PACIFIC = "ASIA_PACIFIC",
  OTHER = "OTHER",
}

export enum NetworkConnectionAction {
  REVOKE = "REVOKE",
  CONNECT = "CONNECT",
}

export enum NetworkConnectionActionStatus {
  APPLIED = "APPLIED",
  FAILED = "FAILED",
}

export enum NetworkTrendDirection {
  UP = "UP",
  DOWN = "DOWN",
  FLAT = "FLAT",
}

export enum NetworkMapNodeRole {
  CLIENT = "CLIENT",
  SERVER = "SERVER",
}

/** How precisely a node or connection could be located. */
export enum NetworkGeoPrecision {
  DEVICE_IP = "DEVICE_IP",
  SERVER_REGION = "SERVER_REGION",
  UNKNOWN = "UNKNOWN",
}

export enum NetworkDestinationSwgStatus {
  PASSED = "PASSED",
  BLOCKED = "BLOCKED",
  UNKNOWN = "UNKNOWN",
}

export enum NetworkAnalyticsGranularity {
  DAY = "DAY",
  WEEK = "WEEK",
  MONTH = "MONTH",
}

/**
 * Window the whole board reports on. Month by default, which is what the trend's "from last month" reads
 * against.
 */
export enum NetworkAnalyticsPeriod {
  WEEK = "WEEK",
  MONTH = "MONTH",
  QUARTER = "QUARTER",
}

/**
 * Days and bucket width per period. A quarter buckets by week rather than by day so the chart stays 13
 * points instead of 90, and 90 days keeps the request inside the backend's 92-day ceiling.
 */
export const NETWORK_ANALYTICS_PERIODS: Record<
  NetworkAnalyticsPeriod,
  { days: number; granularity: NetworkAnalyticsGranularity }
> = {
  [NetworkAnalyticsPeriod.WEEK]: { days: 7, granularity: NetworkAnalyticsGranularity.DAY },
  [NetworkAnalyticsPeriod.MONTH]: { days: 30, granularity: NetworkAnalyticsGranularity.DAY },
  [NetworkAnalyticsPeriod.QUARTER]: { days: 90, granularity: NetworkAnalyticsGranularity.WEEK },
};
